import React from 'react'
import clsx from 'clsx'

export enum InputType {
  Text = 'text',
  Textarea = 'textarea',
  Boolean = 'boolean',
}

interface FieldProps {
  type: InputType
  fieldName: string
  label?: string | React.FunctionComponent
  placeholder?: string
  rows?: number
  validation?: any
  register?: any
  errors: any
  className?: string
  inputClassName?: string
  labelClassName?: string
  disabled?: boolean
  onFocus?: any
}

const FormField: React.FC<FieldProps> = ({
  type,
  fieldName,
  label,
  placeholder,
  rows,
  validation,
  register,
  errors,
  className,
  inputClassName,
  labelClassName,
  disabled = false,
  onFocus,
  ...rest
}) => {
  const cssClass = className ? { className } : {}

  return (
    <div {...cssClass}>
      {type === InputType.Text && (
        <div>
          {label && (
            <label
              htmlFor={fieldName}
              className={clsx('block text-sm leading-5 text-gray-700 dark:text-gray-300', labelClassName)}
            >
              {label}
            </label>
          )}
          <input
            className={clsx(
              'mt-1 block w-full rounded border-gray-300 dark:border-transparent focus:border-blue-300 focus:ring focus:ring-blue-200  focus:ring-opacity-50',
              inputClassName
            )}
            id={fieldName}
            name={fieldName}
            type={type}
            placeholder={placeholder}
            disabled={disabled}
            {...rest}
            {...register(fieldName, validation)}
          />
        </div>
      )}
      {type === InputType.Textarea && (
        <div>
          {label && (
            <label
              htmlFor={fieldName}
              className={clsx('block text-sm leading-5 text-gray-700 dark:text-gray-300', labelClassName)}
            >
              {label}
            </label>
          )}
          <textarea
            className={clsx(
              'mt-1 block w-full rounded border-gray-300 dark:border-transparent focus:border-blue-300 focus:ring focus:ring-blue-200  focus:ring-opacity-50',
              inputClassName
            )}
            id={fieldName}
            name={fieldName}
            placeholder={placeholder}
            rows={rows || 2}
            onFocus={onFocus}
            {...register(fieldName, validation)}
          />
        </div>
      )}
      {type === InputType.Boolean && (
        <label className={clsx('flex items-center space-x-3')}>
          <input
            type="checkbox"
            className={clsx(
              'rounded border-gray-300 dark:border-transparent text-blue-600 dark:text-blue-400 focus:border-blue-300 focus:ring focus:ring-offset-0 focus:ring-blue-200 focus:ring-opacity-50',
              inputClassName
            )}
            id={fieldName}
            name={fieldName}
            {...register(fieldName, validation)}
          />
          <span className={clsx('text-xs leading-4 font-medium text-gray-700 dark:text-gray-300', labelClassName)}>
            {typeof label === 'string' ? label : label({})}
          </span>
        </label>
      )}
      {errors[fieldName] && (
        <div className="mt-1 text-xs text-red-600 dark:text-red-400">{errors[fieldName].message}</div>
      )}
    </div>
  )
}

export default FormField
